import { cx } from "@emotion/css";
import Tooltip from "library/Atoms/Tooltip";
import BriefItemDetailsLayout from "library/Layouts/DetailsLayout/BriefItemDetailsLayout";
import { getOrderPaymentStatusColor, getOrderPaymentStatusIcon } from "pages/Dashboard/utils/helper";
import { PropTypes } from "prop-types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { retrieveContactTimezone } from "store/features/localization.store";
import PaymentStatusType from "types/models/PaymentStatus";
import { formatDate, formatHours } from "utility/date-fns";
import { prettifyStatusLabel } from "utility/helpers/general";
import { REFUNDED_PAYMENT_STATUS } from "../../../../../../constants";
import styles from "./OrderBriefInfo.styles";

const OrderBriefInfo = ({ reference, startDate, endDate, packages, paymentStatus }) => {
  const { t } = useTranslation();

  const timezone = useSelector(retrieveContactTimezone);

  const IconComponent = useMemo(() => getOrderPaymentStatusIcon(paymentStatus), [paymentStatus]);

  return (
    <BriefItemDetailsLayout
      titleSection={t("dashboard.order.reference", { reference })}
      descriptionSection={
        <>
          <span className="text-truncate text-center">{formatDate(startDate, timezone)}</span>

          <span className="px-1">|</span>

          <span className="text-truncate text-center">
            {formatHours(startDate, timezone)} - {formatHours(endDate, timezone)}
          </span>

          <span className="px-1">|</span>

          <span className="text-truncate text-center">
            {t("common.entities.order.packagesCount", { count: packages })}
          </span>

          {paymentStatus && (
            <>
              <span className="px-1">|</span>

              <span className="text-truncate text-center">
                <IconComponent
                  className={cx(styles.icon, "mb-1 mr-1")}
                  color={getOrderPaymentStatusColor(paymentStatus)}
                />

                <span>{t(`utils.paymentStatuses.${paymentStatus}`, prettifyStatusLabel(paymentStatus))}</span>

                {paymentStatus === REFUNDED_PAYMENT_STATUS && (
                  <Tooltip>{t("common.entities.order.refundedTooltip")}</Tooltip>
                )}
              </span>
            </>
          )}
        </>
      }
    />
  );
};

OrderBriefInfo.defaultProps = {
  packages: 0,
  paymentStatus: null,
};

OrderBriefInfo.propTypes = {
  reference: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  packages: PropTypes.number,
  paymentStatus: PaymentStatusType,
};

export default OrderBriefInfo;
